/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Draggable, { DraggableCore } from "react-draggable";
import React from "react";
import { toast } from 'react-toastify';
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal,
  Row,
  Col,
  ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import SelectSearch from './SelectSearch.js';
import ProductDetail from './ProductDetail.js';
import axios from 'axios';
import { connect } from 'react-redux';
import {setProducts, setColours, setSizes, initProducts} from '../../actions/quote'
import {supplier_arry} from "../../config"
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'


function getPosition(string, subString, index) {
  return string.split(subString, index).join(subString).length;
}

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.productModalRef = React.createRef();
  }
  state = {
    selectedProducts:[],
    options:[],
    colournames:[],
    sizenames:[],
    category: {key:'-1',label:''},
    sizeinit:false,
    sizeorder:[],
    loadingproduct: false,
    productCombinations: []
  };
  initOption=(colournames,sizenames)=>{
    var colour = null;
    var size = null;
    if(colournames.length > 0)
      colour = colournames[0]
    if(sizenames.length > 0)
      size = sizenames[0]
    // this.setState({options:[]})
  }
  componentDidMount(){
    // this.props.setProducts([])    
    if(this.props.selectedCategory){
      var categoryId = this.props.selectedCategory
      for (var loop = 0;loop < supplier_arry.length; loop++){
        if(supplier_arry[loop]['key'] == categoryId){
          this.setState({category:  supplier_arry[loop]});
          break;
        }
      }
    }
    if(this.props.selectedProducts){
      this.setState({selectedProducts:  this.props.selectedProducts});    
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedProducts !== this.state.selectedProducts) {
      if(this.state.category){
        this.onChangeProduct(this.props.selectedProducts)
      }
    }
    if (prevState.category !== this.state.category) {
      if(this.state.category && this.state.category.key != -1){        
        // this.setState({sizeinit:false});
        // axios.get(`/products/getsizeorder/${this.state.category.key}`, {
        //   params: {
        //   }
        // }).then(res => {
        //  this.setState({sizeinit:true, sizeorder:res.data.data['sizedata']});
        // })    
      }
    }
  }
  
  changeOptions = (color, size, value, checked)=>{
    var options = {...this.state.options};
    var selectedProducts = this.state.selectedProducts;
    if(selectedProducts.length > 0){
      var selectedProduct = selectedProducts[0]
      var codeId = (selectedProduct.shortcode)
      var category = this.state.category
      var products = [];
      if(category.key != "-1" && codeId){
        var product_options = {...options[category.key]};
        var color_options = {...product_options[codeId]};
        var size_options = {...color_options[color]}
        size_options[size] = value;        
        color_options[color] = size_options; 
        product_options[codeId] = color_options;
        options[category.key] = product_options;
      }   

      console.log("changeOptions", options)
      this.setState({options:options})
    }
  }
  onChangeProduct=async selectedProducts => {
    var categoryId = this.state.category?this.state.category.key:null
    console.log("onChangeProduct", selectedProducts, categoryId)
    if(selectedProducts && selectedProducts.length > 0 && categoryId && categoryId != -1){
      var selectedProduct = selectedProducts[0];
      var productInfo = {};
      var colournames = [];
      var sizenames = [];
      var productCombinations = [];
      var sizeorder = [];
      this.setState({productInfoLoading: true})
      var res = await axios.get(`/products/getproductbyshortcode/${categoryId}?shortcode=${selectedProduct.code}`);
      var result = res.data
      if(result.status == "success"){
        productInfo = result.data?result.data.product:{}
        sizenames = result.data?result.data.sizenames:[]
        colournames = result.data?result.data.colornames:[]
        productCombinations = result.data?result.data.productCombinations:[]
        sizeorder = result.data?result.data.sizeorder:[]
      }
      this.setState({productInfoLoading: false})
      sizenames.sort((a, b) =>{
        var size_a = (sizeorder[a]?sizeorder[a]:0)
        var size_b = (sizeorder[b]?sizeorder[b]:0)
        var result = (size_a > size_b) ? 1 : -1
        return result;
      }) 
      this.setState({colournames, sizenames, productCombinations})
      this.setState({selectedProducts:  [productInfo]});
      this.initOption(colournames,sizenames);
    }
  }
 
  
  checkDisable=(codeId, colour, size)=>{
    var products = this.state.productCombinations;
    for (var loop1 = 0; loop1 < products.length; loop1++){
      var product = products[loop1];
      if((product.shortcode) == (codeId)){
      // if(product.code.includes(codeId)){
        if(
          (product.colour == colour && (size!=null && size != "null" && product.size == size))||
          (product.colour == colour && (size==null || size == "null"))               
        )
        {
          return false;
        }
      }
    }
    return true;
  }
  onAddProducts=()=>{
    console.log("product", this.state.selectedProducts); 
    var totalQty = 0;
    var categoriesAdd = {};
    // if(selectedProducts.length > 0)
      var options = this.state.options;
    for(var category in options)
    {
      var productsAdd = []
      var product_options = options[category];
      for(var codeId in product_options){
        var color_options = product_options[codeId]
        for(var colour in color_options){
          var line = color_options[colour];
          for(var size in line){
            var qty = line[size];
            if(qty > 0 && qty){
              var products = this.state.productCombinations;
              
              for (var loop1 = 0; loop1 < products.length; loop1++){
                var product = products[loop1];
                if((product.shortcode) == (codeId)){
                  if(
                    (product.colour == colour && (size!=null && size != "null" && product.size == size))||
                    (product.colour == colour && (size==null || size == "null"))               
                  )
                  {
                    var productToAdd = {...product}
                    productToAdd.qty = qty*1
                    productsAdd.push(productToAdd)
                  }
                }
              }
              totalQty+= qty*1;
            }
          }
      }    
    }
    
    if(category != "-1"){
      categoriesAdd[category] = productsAdd;
    }

    }
    if(totalQty > 0){
      toast.success("The products have been added into the list");
      this.setState({options:[]})
      this.props.onAdd(categoriesAdd, this.state.category)
    }
  }
  onChangeCategory=(values)=>{
    if(values && values.length> 0){
      {this.setState({category:  values[0]});}
      var colournames=[];
      var sizenames=[];
      this.setState({colournames, sizenames})
      this.setState({selectedProducts:  []});
      this.initOption(colournames,sizenames);
      // if(this.props.isOpen){      
      //   this.props.setProducts([])
      //   axios.get(`/products/getproducts/${values[0].key}`).then(res => {
      //     if(res.data.status == "success"){
      //       var data = res.data.data;
      //       console.log("products",data);
      //       this.props.setProducts(data.products)
      //       this.props.setColours(data.colournames)
      //       this.props.setSizes(data.sizenames)
      //     }
      //   })    
      // }
    }
  }
  render() {
    const isOpen = this.props.isOpen;
    const toggle = this.props.toggle;    
    const productInfo =  this.props.quote.productInfo;
    var category = this.state.category
    var productOptions = [];
    var colournames = this.state.colournames;
    var sizenames = this.state.sizenames;
    if(category.key != "-1"){
      if(productInfo[category.key]){
        productOptions = productInfo[category.key].products;       
      }
    }

    var selectedProducts = this.state.selectedProducts;
    var selectedProduct = null
    if(selectedProducts.length > 0){
      selectedProduct = selectedProducts[0];
    }
  
    return (
      <>
        <Draggable>
          <Modal id="product-modal" className={sizenames.length > 10?"full-width":""} ref={this.productModalRef} isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
              <h3 className="h4 font-weight-bold mb-0">
                Add Product
              </h3>
            </ModalHeader>
            <ModalBody>
              <div className="product-selector">
                <div style={{margin:'0 5px'}}>
                  <SelectSearch options={supplier_arry} placeholder="START TYPING Catalogue" onChange={values => {this.onChangeCategory(values)}} searchBy="label" labelField="label" valueField="key" values={this.state.category.key=="-1"?[]:[supplier_arry.find(opt => opt.key === this.state.category.key)]}/>
                </div>
                <div style={{margin:'0 5px'}}>
                  <SelectSearch options={productOptions} placeholder="START TYPING PRODUCT OR SKU" onChange={(values)=>this.onChangeProduct(values)} searchBy="code" additionalSearchBy="sku" labelField="code" valueField="id" values={selectedProducts} />
                  {/* <SelectSearch options={productOptions} placeholder="START TYPING PRODUCT OR CODE" onChange={(values)=>this.onChangeProduct(values)} searchBy="code" labelField="code" valueField="id" values={selectedProducts} /> */}
                </div>
              </div>
              {/* {this.state.productInfoLoaded && */}
              <ProductDetail product={selectedProduct} category={this.state.category} colournames={colournames} sizenames={sizenames}
                options={this.state.options}
                changeOptions = {(color, key, value, checked)=>this.changeOptions(color, key, value, checked)}
                checkDisable = {this.checkDisable}
              />
              {/* } */}
            </ModalBody>
            <div style={{display:'flex', justifyContent:'flex-end', padding:"20px"}}>
              <Button color="primary" onClick={()=>this.onAddProducts()}>Add Product</Button>{' '}
              <Button color="secondary" onClick={toggle}>Continue</Button>
            </div>
          </Modal>
        </Draggable>
        
        <LoadingOverlay
            active={this.state.productInfoLoading}
            styles={{
                overlay: (base) => ({
                ...base,
                fontSize:'18px',
                color: 'rgb(5, 37, 51)',
                background: 'rgb(60 60 60 / 48%)',
                position:'fixed',
                zIndex:1000000000
                })
            }}
            spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
            // spinner
            // text='Loading ...'
            >
        </LoadingOverlay> 
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    initProducts: products=>dispatch(initProducts(products)),
    setColours: colours=>dispatch(setColours(colours)),
    setSizes: sizes=>dispatch(setSizes(sizes)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Product);